import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MobileSubNavigator from '../../components/MobileSubNavigator';
import { useLocation, useNavigate } from 'react-router-dom';

const staticLinks = [
  // { path: '/Coupon/coupon-types', label: '쿠폰종류목록' },
  // { path: '/Coupon/coupon-sets', label: '쿠폰세트' },
  // { path: '/Coupon/coupon-stats', label: '쿠폰통계' },
  // { path: '/Coupon/all-coupons', label: '전체쿠폰' },
  // { path: '/Coupon/verified-coupons', label: '인증쿠폰' },
  // { path: '/Coupon/used-coupons', label: '사용쿠폰' },
  // { path: '/Coupon/pos-settlement', label: 'POS정산' },
  // { path: '/Coupon/pos-log', label: 'POS로그' },
  // { path: '/Coupon/social-coupon-issuance', label: '소셜쿠폰발행' },
  // { path: '/Coupon/youtube-premium', label: '유튜브프리미엄' },
];

const MobileCoupon = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState(staticLinks);

  useEffect(() => {
    // API 호출하여 테이블 이름 가져오기
    const fetchBoardTables = async () => {
      try {
        console.log('=== MobileCoupon fetchBoardTables 시작 ===');
        console.log(`Current URL: ${window.location.href}`);
        console.log(`API URL: ${window.location.origin}/request/getBoardTables?category=Coupon`);
        
        const response = await fetch('/request/getBoardTables?category=Coupon', { 
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        });
        
        console.log(`Response status: ${response.status}`);
        console.log(`Response URL: ${response.url}`);
        
        if (!response.ok) {
          console.error(`HTTP Error: ${response.status} - ${response.statusText}`);
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('받은 데이터:', data);
        console.log('데이터 타입:', typeof data);
        console.log('배열인가?', Array.isArray(data));

        // 서버에서 배열을 직접 반환하므로 그대로 사용
        let dynamicLinks = [];
        if (Array.isArray(data)) {
          // 가져온 테이블 이름을 링크로 변환
          dynamicLinks = data.map(table => ({
            path: `/Coupon/Board/${table.boardId}`,
            label: table.boardTitle
          }));
        } else if (data && data.result && Array.isArray(data.result)) {
          // 혹시 다른 구조일 경우를 대비
          dynamicLinks = data.result.map(table => ({
            path: `/Coupon/Board/${table.boardId}`,
            label: table.boardTitle
          }));
        }

        console.log('생성된 동적 링크들:', dynamicLinks);
        
        // 정적 링크와 동적 링크 결합
        setLinks([...staticLinks, ...dynamicLinks]);
      } catch (error) {
        console.error('Error fetching board tables:', error);
        console.error('Error details:', error);
        // 오류 발생 시 빈 배열로 설정하여 무한 로딩 방지
        setLinks(staticLinks);
      }
    };

    fetchBoardTables();
  }, []);

  useEffect(() => {
    if (links.length > 0) {
      if (location?.state?.fromNavigator === true) {
        navigate(links[0].path);
      }
    }
  }, [location, links, navigate]);

  return (
    <MobileSubNavigator 
      links={links} 
      sectionTitle="쿠폰 관리"
      backPath="/"
    >
      <Outlet />
    </MobileSubNavigator>
  );
};

export default MobileCoupon;